import { useState, useEffect, useRef, useMemo } from "react";
import styled from "styled-components";
import {
  generateUrl,
  getDefaultMenuTab,
  openTarget,
  setRouting,
  isShowAllTabs,
  adobeData,
  generateAdobeDataRaceNo,
} from "@/app/utils/Common";
import _ from "lodash";
import { useMyContext } from "@/app/utils/MyContext";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";
import { MenuTab as MenuClass } from "@/app/utils/class/common/base";
import { textSize, text_size } from "@/app/utils/MixinSize";
import { menuTabSet } from "@/app/utils/constant/menuTabSet";
import Tips from "@/app/ui/Common/Tips";

interface propType {
  setRacesDetailLoading?: (loading: boolean) => void;
  onChange?: (tab: string) => void;
  type?: string;
  currentTab?: string;
  menuData: any;
  onTips2Display?: ()=>void;
  onTips2Dismiss?: ()=>void;
  clickTipOnly?: boolean;
  showTips2?: any;
}
const PcContainer = styled.div`
  z-index: 110;
  position: relative;
  width: 100%;
  background: white;
  box-shadow: 0px 2px 10px 0px #0000001A;
  border-radius: 4px 4px 0 0;
`;
const Level3Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
   > .tab_non_selected:not(:hover) + .tab_non_selected:not(:hover) {
    >.tab_itemText {
      border-left: 1px solid #979797;
    }
  }

  > div:first-child {
    border-radius: 4px 0 0 0;
  }
  > div:last-child {
    border-radius: 0 4px 0 0;
  }
`; 
const Level3Item = styled.div<{ selected?: boolean; $isDisable?: boolean }>` 
  position: relative;
  flex: 1;
  text-align: center;
  display: flex;
  padding: 6px 0;
  align-items: center;
  cursor: ${({ $isDisable }) => ($isDisable ? "default" : "pointer")};
  div {
    color: ${({ $isDisable }) => $isDisable && "#8B8B8B"};
  }
  ${({ $isDisable, selected }) =>
    `
    background: ${$isDisable ? "#CCCCCC" : selected ? "#173e96" : "none"};
    &:hover{
      background: ${!$isDisable && !selected && "rgba(23, 62, 150, 0.9)"};
      div{
        color:  ${!$isDisable && !selected && "white"};
      }
    }
    `}
`;
const ItemText = styled.div<{ isitemlast: string }>`
  width: 100%;
  height: 24px;
  ${text_size(13)}
  font-weight: 500;
  text-align: center;
  line-height: 24px;
  color: #333333;
`;
const ItemTextSelected = styled.p`
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  ${text_size(13)}
  font-weight: 500;
  color: white;
`;
const Level4ItemWrapper = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  top: 36px;
  border: 1px solid rgba(226, 237, 246, 1);
  border-radius: 0px, 0px, 4px, 4px;
  box-shadow: 0px 3px 10px 0px #0000004D;
  div:nth-last-of-type(1) {
    border-radius: 0px 0px 4px 4px;
  }
  > .tab_level4Item + .tab_level4Item {
    border-top: 1px solid #B4B4B4;
  }
`;
const Level4Item = styled.div<{ $isDisable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $isDisable }) => ($isDisable ? "default" : "pointer")};
  background: ${({ $isDisable }) => ($isDisable ? "#CCCCCC" : "white")};
  padding: 10px;
  margin: -1px;
  p {
    ${text_size(13)}
    font-weight: 500;
    text-align: center;
    color: ${({ $isDisable }) => ($isDisable ? "#8B8B8B" : "#333333")};
  }
  &:hover {
    background: ${({ $isDisable }) => ($isDisable ? "#CCCCCC" : "#173e96")};
    p {
      color: ${({ $isDisable }) => ($isDisable ? "#8B8B8B" : "white")};
    }
  }
`;
const MobileContainer = styled.div`
  position: relative;
`;
const MobileTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px  8px 12px;
  background: white;
  border-bottom: 1px solid #b4b4b4;
  border-radius: 4px 4px 0 0;
`;
const MTitle = styled.p`
  ${text_size(15)}
  font-weight: 500;
  line-height: 18px;
  text-align: left;
`;
const MSelectBtn = styled.img<{ isShowSelect: boolean }>`
  width: 27.07px;
  height: 28px;
  transform: ${({ isShowSelect }) =>
    isShowSelect ? "rotate(-180deg)" : "rotate(0deg)"};
`;

const SelectContainer = styled.div`
  width: calc(100% - 40px);
  position: absolute;
  background: white;
  z-index: 777;
  left: 20px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  overflow-y: auto;
  transition: all 0.4s ease-in-out;
`;
const SelectTitle = styled.div`
  display: flex;
  height: 37px;
  align-items: center;
  border-radius: 4px 4px 0 0;
  width: 100%;
  background: rgba(19, 43, 104, 1);
  img {
    margin-left: 9px;
  }
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 21px;
    text-align: left;
    padding: 9.5px 5.4px;
    color: white;
  }
`;
const SelectItem = styled.div<{ $isLast: boolean; $isDisable?: boolean }>`
  padding: 0 8px;
  background: ${({ $isDisable }) => ($isDisable ? "#CCCCCC" : "white")};
  p {
    padding: 10px 0;
    ${text_size(15)}
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    color: ${({ $isDisable }) =>
    $isDisable ? "#8B8B8B" : "rgba(51, 51, 51, 1)"};
    border-bottom: ${({ $isLast }) =>
    $isLast ? "none" : "1px solid rgba(180, 180, 180, 1)"};
  }
  &:active {
    p {
      color: ${({ $isDisable }) => ($isDisable ? "#8B8B8B" : "white")};
    }
    background: ${({ $isDisable }) =>
    $isDisable ? "#CCCCCC" : "rgba(23, 62, 150, 1)"};
    padding: 0;
    border-bottom: none;
    &::after {
      width: 0px;
    }
  }
`;
interface MenuData {
  name: string;
  showNextLv: boolean;
  seq: number;
  redirection: string;
  redirectionJCRWPage: string;
  target?: "_blank" | "_self";
  displayName: string;
  link?: string;
  nextLevel?: MenuData[];
  disable?: boolean;
}

const formGuideDisplayName = "form guide";

const MenuTab: React.FC<propType> = (props: propType) => {
  const [tabData, setTabData] = useState<MenuData[]>([]);
  const [mTab, setMTab] = useState("");
  const [isShowSelect, setIsShowSelect] = useState(false);
  const [level, setLevel] = useState(1);
  const [title, setTitle] = useState("");
  const [level2Data, setLevel2Data] = useState<MenuData[]>([]);
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [openSelectEvent, setOpenSelectEvent] = useState<any>(null);

  useEffect(() => {
    if (props.menuData) {
      const data = props.menuData;
      const newData = handleMenu(data);
      handleMenuTabNotExistOnChange(newData);
      setTabData(newData);
    }
  }, [props.menuData]);
  const handleMatchItem = (arr: MenuData[], isSubItem?: boolean) => {
    arr.some((item:MenuData)=>{
      if (myContextState.menuTab?.isEqual(item?.displayName)) {
        setMTab(item?.name);
        if (isSubItem){
          setTitle("");
        }
        return
      } else if (item?.nextLevel && item?.nextLevel.some((sub: MenuData)=>myContextState.menuTab?.isEqual(sub?.displayName))) {
        setTitle(item?.name);
        handleMatchItem(item?.nextLevel, true);
        return
      }
    })
  }
  useEffect(() => {
    if (props.type === "pc") return;
    handleMatchItem(tabData);
  }, [myContextState.menuTab]);
  useEffect(() => {
    if (props.clickTipOnly && props.showTips2 && !myContextState.isLoadingRaces) {
      setTimeout(() => {
        console.log("scrollIntoView")
        const dom = document.getElementById("race_detail_wrapper");
        dom?.scrollIntoView();
      }, 1000); 
    }
  }, [props.clickTipOnly, props.showTips2, myContextState.isLoadingRaces]);
  const handleMenuTabNotExistOnChange = (data: any) => {
    // check if item/children match with menuTab and is not disabled
    const menuTabIsEnable = data.some((d: any) =>
      d.nextLevel?.length
        ? d.nextLevel?.some(
            (subD: any) =>
              myContextState.menuTab.isEqual(subD?.displayName) &&
              subD?.disable === false
          )
        : myContextState.menuTab.isEqual(d.displayName) && d.disable === false
    );

    // feat: PRJ2555-1329 part 2/2, default landing page on page is not existed
    if (!menuTabIsEnable) {
      console.log("route 5");
      const defaultMenuTab = getDefaultMenuTab(
        myContextState.bizDate,
        myContextState.selectedMeeting
      );
      setRouting(
        `/${encodeURIComponent(
          defaultMenuTab.valueOf()
        )}`,
        undefined, 
        myContextState
      );
      myContextDispatch({ type: "update", value: { menuTab: defaultMenuTab } });
    }
  };

  const handleMenu = (data: any) => {
    const dimTabList = [
      menuTabSet.CHANGES,
      menuTabSet.RACE_CARD,
      menuTabSet.REFERENCE_ODDS,
      menuTabSet.GENERAL_INFORMATION,
      menuTabSet.RACING_STATISTICS,
      menuTabSet.TRAINERS_ENTRIES_FOR_THE_DAY,
      menuTabSet.JOCKEYS_RIDES_FOR_THE_DAY,
      menuTabSet.RACE_SUMMARY,
      menuTabSet.JOCKEY_TRAINER_RANKING,
      menuTabSet.CURRENT_ODDS,
      menuTabSet.FORM_COMMENT,
      menuTabSet.TIPSTERS_SELECTION,
      menuTabSet.EXPERT_COLUMN,
      menuTabSet.TRACK_ANALYSIS,
      menuTabSet.NEWS,
      menuTabSet.ENTRIES,
    ];

    let newD = data
      ?.filter((x: any) => x.label.value)
      ?.map((item: any, i: number) => {
        if (myContextState.menuTab?.isEqual(item?.displayName))
          setMTab(item.label.value);
        if (
          item.displayName.toLowerCase() === formGuideDisplayName &&
          !myContextState.selectedRaceFormGuideUrl
        )
          return;
        let isAllChildrenDisable = false;
        if (item.hasChildren) {
          isAllChildrenDisable = !handleMenu(item.children).some(
            (i) => i && !i.disable
          );
        }
        const disableTab =  isAllChildrenDisable  || (myContextState.selectedMeeting?.isPostRace(myContextState.bizDate) && dimTabList.includes(item.displayName.toLowerCase())) ||(menuTabSet.CURRENT_ODDS == item.displayName.toLowerCase() && (myContextState.selectedMeeting?.isBeforeStartSell() || myContextState.selectedMeeting?.isMeetingFinished()))
        const GetLink=(item:any)=>{
          if(item.displayName.toLowerCase() === formGuideDisplayName){
            return myContextState.selectedRaceFormGuideUrl
          }
          else if(menuTabSet.CURRENT_ODDS == item.displayName.toLowerCase()){
            return generateUrl(item?.redirectionURL?.value, {'b_cid': 'SPLDSP_racing/simulcast-IA_Odds'}, false, true);            
          }
          else{
            return item?.redirectionURL?.value
          }
        }
        return {
          name: item.label.value,
          showNextLv: false,
          seq: item.seq?.value ?? 0,
          redirectionTarget: item?.redirection?.value,
          redirectionJCRWPage: item?.redirectionJCRWPage?.value,
          target: openTarget(item?.target?.value),
          displayName: item?.displayName,
          link: GetLink(item),
          nextLevel: item.hasChildren ? handleMenu(item.children) : undefined,
          disable: !isShowAllTabs() && disableTab,
          // disableTabChange:
          //   openTarget(item?.target?.value) === "_blank" && !item.hasChildren,
        };
      });
    return _.orderBy(newD, ["seq"], ["asc"]);
  };

  const handleMouseEnter = (tabName: string) => {
    const updatedTabs = tabData?.map((tab: any) => ({
      ...tab,
      showNextLv: tab.name === tabName,
    }));

    setTabData(updatedTabs);
  };
  const handleClickTab = (item: any) => {
    if (item.disable) return;
    const curRace = myContextState.selectedMeeting?.RaceMeetingProfile?.races?.find((r: any) => r.no == myContextState?.selectedRaceNo.valueOf());

    if (item.redirectionTarget == "JCRW page") {
      adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
        pageId: "racing/simulcast",
        eventId: "racing/simulcast_Click_AnyPage_Menu-IA",
        country: myContextState.selectedMeeting?.countryNameEn || '',
        buttonName: "racing/simulcast_Click_" + item.displayName,
        raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
      });

      handleTabHoverLeave4();
      if (item.target == "_self") {
        props.onChange?.(item.redirectionJCRWPage || menuTabSet.RACE_SUMMARY);
      } else {
        openTabInNewWindow(item);
      }
    } else if (item.redirectionTarget == "Other link") {
      adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
        pageId: "racing/simulcast",
        eventId: "racing/simulcast_Click_AnyPage_Menu-IA",
        country: myContextState.selectedMeeting?.countryNameEn || '',
        buttonName: "racing/simulcast_Click_" + item.displayName,
        raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
      });

      handleTabHoverLeave4();
      window.open(item.link, item.target);
    } else {
      return;
    }
  };

  const handleTabHoverLeave4 = () => {
    const updateTabs = tabData?.map((tab: any) => ({
      ...tab,
      showNextLv: false,
    }));
    setTabData(updateTabs);
  };

  const handleShowTabM = (event: any) => {
    event.stopPropagation();
    if (!isShowSelect) {
      window.addEventListener("mousedown", handleOutSideClick);
    }
    setIsShowSelect(!isShowSelect);
    setOpenSelectEvent(event.target);
  };

  useEffect(() => {
    const selDom = document.getElementById("selDom");
    if (selDom) {
      if (isShowSelect) {
        selDom.style.maxHeight = "999px";
        selDom.style.opacity = "1";
      } else {
        selDom.style.maxHeight = "0";
        selDom.style.opacity = "0";
      }
    }
  }, [isShowSelect]);

  const back = () => {
    setTitle("");
    setLevel(1);
  };

  const ref = useRef(null);
  const handleOutSideClick = (event: { target: any }) => {
    if (
      !(ref.current as any)?.contains(event.target) &&
      !openSelectEvent?.contains(event.target)
    ) {
      setIsShowSelect(false);
      setTimeout(() => {
        back();
      }, 500);
      window.removeEventListener("mousedown", handleOutSideClick);
    }
  };

  const openTabInNewWindow = (item: any) => {
    const tablink = new MenuClass(
      item.redirectionJCRWPage || menuTabSet.RACE_SUMMARY
    );
    if (tablink.isValid()) {
      const link = generateUrl(
        `/${encodeURIComponent(
          tablink.valueOf()
        )}`,
        { redirect: "N" },
        true
      );
      console.log(link);
      window.open(link);
    }
  };

  const renderSelectDataM = () => {
    const handleTab = (item: any, type?: string) => {
      if (item.disable) return;
      if (item.nextLevel) {
        if (type === "lv2") {
          if (item.redirectionTarget == "JCRW page") {
            if (item.target == "_self") {
              setMTab(item.name);
              props.onChange?.(
                item.redirectionJCRWPage || menuTabSet.RACE_SUMMARY
              );
            } else {
              close();
              openTabInNewWindow(item);
            }
          } else if (item.redirectionTarget == "Other link") {
            close();
            window.open(item.link, item.target);
          } else {
            close();
            return;
          }
        } else {
          setTitle(item.name);
          setLevel2Data(item.nextLevel);
          setLevel(2);
        }
      } else {
        const curRace = myContextState.selectedMeeting?.RaceMeetingProfile?.races?.find((r: any) => r.no == myContextState?.selectedRaceNo.valueOf());
        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
          pageId: "racing/simulcast",
          eventId: "racing/simulcast_Click_AnyPage_Menu-IA",
          country: myContextState.selectedMeeting?.countryNameEn || '',
          buttonName: "racing/simulcast_Click_" + item.displayName,
          raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });
        
        if (item.redirectionTarget == "JCRW page") {
          if (item.target == "_self") {
            setIsShowSelect(!isShowSelect);
            setMTab(item.name);
            props.onChange?.(
              item.redirectionJCRWPage || menuTabSet.RACE_SUMMARY
            );
            setTimeout(() => {
              setLevel(1);
            }, 500);
          } else {
            close();
            openTabInNewWindow(item);
          }
        } else if (item.redirectionTarget == "Other link") {
          close();
          window.open(item.link, item.target);
        } else {
          close();
          return;
        }
      }
    };

    const close = () => {
      setIsShowSelect(false);
      back();
    };

    return (
      <SelectContainer id="selDom" ref={ref}>
        <SelectTitle id={`current_Lv1tab_${title}`}>
          {level === 2 ? (
            <img onClick={() => back()} src={`${myContextState.assetPrefix}/navigate_before.svg`} />
          ) : null}
          <p>{title}</p>
        </SelectTitle>
        {level === 1
          ? tabData?.map((item: MenuData, index: Number) => {
              if (!item) return;
              return (
                <SelectItem
                  id={`Lv1_tab_${item.name}`}
                  onClick={() => handleTab(item)}
                  key={item.name + "_" + index}
                  $isLast={(index === tabData.length - 1) || false}
                  $isDisable={item.disable}
                >
                  <p> {item.name} </p>
                </SelectItem>
              );
            })
          : level2Data?.map((item: MenuData, index: Number) => {
              if (!item) return;
              return (
                <SelectItem
                  id={`Lv2_tab_${item.name}`}
                  onClick={() => handleTab(item, "lv2")}
                  key={item.name + "_" + index}
                  $isLast={(index === level2Data.length - 1) || false}
                  $isDisable={item.disable}
                >
                  <p> {item.name} </p>
                </SelectItem>
              );
            })}
      </SelectContainer>
    );
  };

  const renderPCData = () => {
    return (
      <Level3Wrapper
        id="tab_menu_navigation"
        onMouseLeave={handleTabHoverLeave4}
      >
        {tabData?.map((item: MenuData | undefined, index: number) => {
          if (!item) return;
          const selected =
            myContextState.menuTab?.isEqual(item?.displayName) ||
            item?.nextLevel?.some((c: any) =>
              myContextState.menuTab?.isEqual(c?.displayName?.toLowerCase())
            );
          return (
            <Level3Item
              key={index}
              onMouseEnter={() => handleMouseEnter(item.name)}
              onClick={() => handleClickTab(item)}
              selected={selected}
              $isDisable={item.disable}
              className={selected ? "" : "tab_non_selected"}
            >
              {selected ? (
                <ItemTextSelected id={`tab_${item.name}_selected`}>
                  {item.name}
                </ItemTextSelected>
              ) : (
                <ItemText
                  id={`tab_${item.name}`}
                  className="tab_itemText"
                  isitemlast={index === tabData.length - 1 ? "true" : "false"}
                >
                  {item.name}
                </ItemText>
              )}
              {item.nextLevel && item.showNextLv && (
                <Level4ItemWrapper onMouseLeave={handleTabHoverLeave4}>
                  {item.nextLevel.map(
                    (menu: MenuData | undefined, index: number) => {
                      if (!menu) return;
                      return (
                        <Level4Item
                          className="tab_level4Item"
                          id={`menu_${menu.name}_${index}`}
                          key={menu.name}
                          onClick={() => handleClickTab(menu)}
                          $isDisable={menu.disable}
                        >
                          <p> {menu.name} </p>
                        </Level4Item>
                      );
                    }
                  )}
                </Level4ItemWrapper>
              )}
            </Level3Item>
          );
        })}
      </Level3Wrapper>
    );
  };

  return (
    <>
      {!myContextState.selectedMeeting?.isPresite() &&
        (props.type === "pc" ? (
          <PcContainer>{renderPCData()}</PcContainer>
        ) : (
          <MobileContainer>
            <MobileTitle id={`mtab_title`}  onClick={handleShowTabM}>
              <MTitle>{mTab}</MTitle>
              <MSelectBtn
                id="menuTabSelectBtn"
                isShowSelect={isShowSelect}
                onClick={handleShowTabM}
                src={`${myContextState.assetPrefix}/bottomArrow.svg`}
              />
            </MobileTitle>
            {props.showTips2 && (
              <Tips
                localStoragekey="tip2"
                message={t("mobile_dropdown_menu_tips2")}
                onDisplay={props.onTips2Display}
                onDismiss={props.onTips2Dismiss}
              />
            )}
            {renderSelectDataM()}
          </MobileContainer>
        ))}
    </>
  );
};
export default MenuTab;
